<template>
  <div>
    {{ $t('useApp.begin') }}
    <div class="mt-3">
      <h4>1. {{ $t('useApp.header')[0] }}</h4>
      {{ $t('useApp.content')[0] }}
      <div>
        <img class="m-1 w-100" alt="step 1" src="@/assets/use-app-1.jpg">
      </div>
    </div>
    <div class="mt-3">
      <h4>2. {{ $t('useApp.header')[1] }}</h4>
      {{ $t('useApp.content')[1] }}
      <div>
        <img class="m-1 w-100" alt="step 2" src="@/assets/use-app-2.jpg">
      </div>
    </div>
    <div class="mt-3">
      <h4>3. {{ $t('useApp.header')[2] }}</h4>
      {{ $t('useApp.content')[2] }}
      <div>
        <img class="m-1 w-100" alt="step 3" src="@/assets/use-app-3.jpg">
      </div>
    </div>
    <div class="mt-3">
      <h4>4. {{ $t('useApp.header')[3] }}</h4>
      {{ $t('useApp.content')[3] }}
      <div>
        <img class="m-1 w-100" alt="step 4" src="@/assets/use-app-4.jpg">
      </div>
    </div>
    {{ $t('useApp.end') }}
  </div>
</template>

<script>
export default {
  name: 'InstallApp',
}
</script>
